<template>
  <div class="logo">
    <img src="../assets/logo.png"
         alt=""
         class="logoImg">
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.logo {
  width: 116px;
  height: 123px;
  background: rgba(252, 224, 79, 1);
  display: flex;
  align-items: center;
  justify-content: space-around;
  .logoimg {
    width: 82px;
    height: 50px;
  }
  img{
    width: 82px;
    height: 50px;
  }
}
</style>
